import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const yardtechnician = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/yard/{profile}/yard-technician',
    app: 'yard'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'yard', model: 'yardtechnician' }
    ),
    { }
  )
)()

export { yardtechnician, TYPES }
